<template>
    <div class="home">
        <div class="tree-container">
            <div class="relation" ref="graphContainer"></div>
        </div>
        <el-dialog
                :title="'对'+currentNode.name+'操作'"
                :visible.sync="showToolMenu"
                v-if="currentNode!=null"
                :close-on-click-modal="false"
        >
            <div class="btns">
                <div class="hf">
                    <el-button type="primary" @click="editPerson" icon="el-icon-edit">编辑信息</el-button>
                </div>
                <div class="hf">
                    <el-popconfirm title="确定要删除这个节点吗？" @confirm="deleteNode">
                        <el-button type="warning" slot="reference" icon="el-icon-delete">删除人物</el-button>
                    </el-popconfirm>
                </div>
                <div class="hf">
                    <el-button type="success" @click="addLink" icon="el-icon-link">建立关系</el-button>
                </div>
                <div class="hf">
                    <el-button type="success" @click="listLink" icon="el-icon-cpu">管理关系</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog
                :title="whichTitle"
                :visible.sync="showPerson"
                :close-on-click-modal="false"
        >
            <el-form :model="editForm" status-icon :rules="rules" ref="editForm" label-width="60px">
                <el-form-item label="头像" prop="photo">
                    <!--                    <el-input v-model="editForm.photo"></el-input>-->
                    <el-upload
                            class="avatar-uploader" :class="{tx:editForm.photo}"
                            action="https://jsonplaceholder.typicode.com/posts/"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                        <template v-if="editForm.photo">
                            <img :src="editForm.photo" class="avatar">
                            <i class="el-icon-delete" @click.stop="handleRemove"></i>
                        </template>
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <el-input v-model="editForm.photo"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="editForm.name" type="textarea" rows="3"></el-input>
                </el-form-item>
                <el-form-item label="别名">
                    <el-input v-model="editForm.alias" type="textarea" rows="2"></el-input>
                </el-form-item>
                <el-form-item label="性別" prop="gender">
                    <el-radio-group v-model="editForm.gender">
                        <el-radio label="男">男</el-radio>
                        <el-radio label="女">女</el-radio>
                        <el-radio label="无">无</el-radio>
                        <el-radio label="图">图</el-radio>
                        <el-radio label="物">物</el-radio>
                        <el-radio label="文字">文字</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="缩放" v-if="editForm.gender=='图'">
                    <el-slider v-model="editForm.photoScale" :format-tooltip="formatTooltip"></el-slider>
                </el-form-item>
                <el-form-item label="颜色" v-if="editForm.gender=='文字'||editForm.gender=='物'">
                    <el-color-picker :predefine="predefineColors" v-model="editForm.color"></el-color-picker>
                </el-form-item>
                <el-form-item label="宽度" v-if="editForm.gender=='文字'">
                    <el-radio-group v-model="editForm.textWidth">
                        <el-radio label="auto">自动</el-radio>
                        <el-input v-model="editForm.textWidth"></el-input>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="位置"
                              v-if="editForm.gender=='文字'&&(editForm.textWidth!='auto'&&editForm.textWidth!=undefined)">
                    <el-radio-group v-model="editForm.textPo">
                        <el-radio label="bottom">下</el-radio>
                        <el-radio label="top">上</el-radio>
                        <el-radio label="left">左</el-radio>
                        <el-radio label="right">右</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div style="display: flex;">
                    <el-col>
                        <el-form-item label="出生">
                            <el-date-picker type="date" placeholder="选择日期"
                                            v-model="editForm.birthDate" value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="死亡">
                            <el-date-picker type="date" placeholder="选择日期"
                                            v-model="editForm.deathDate" value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </div>
                <el-form-item label="介绍">
                    <el-input type="textarea" v-model="editForm.details" rows="6"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('editForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
                :title="whichTitleLink"
                :visible.sync="showLink"
                :close-on-click-modal="false"
        >
            <el-form :model="linkForm" status-icon :rules="rulesL" ref="linkForm" label-width="80px">
                <el-form-item label="关系源" prop="source">
                    <el-input v-model="linkForm.source" v-if="currentNode" disabled></el-input>
                    <el-input v-model="linkForm.source" v-else></el-input>
                </el-form-item>
                <el-form-item label="关系目标" prop="target">
                    <el-input v-model="linkForm.target" v-if="currentLink" disabled>></el-input>
                    <el-input v-model="linkForm.target" v-else></el-input>
                </el-form-item>
                <el-form-item label="关系类型" prop="type">
                    <el-input v-model="linkForm.type"></el-input>
                </el-form-item>
                <el-form-item label="箭头显示" v-if="!linkForm.type">
                    <el-checkbox v-model="linkForm.showArrow"></el-checkbox>
                </el-form-item>
                <el-form-item label="位置">
                    <el-radio-group v-model="linkForm.po">
                        <el-radio label="center">中间</el-radio>
                        <el-radio label="end">尾部</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="介绍">
                    <el-input type="textarea" v-model="linkForm.details" rows="6"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm1('linkForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
                :title="linkList"
                :visible.sync="showLinkList"
                :close-on-click-modal="false"
        >
            <ul class="linkList">
                <li v-for="item in currentLinkList">
                    <div class="ti">
                        <span class="yellow">{{toName(item.source.id)}}</span>的<span class="yellow">{{item.type}}</span>是<span
                            class="yellow">{{toName(item.target.id)}}</span>
                    </div>
                    <div class="dos">
                        <i class="el-icon-edit" @click="editLink(item)"></i>
                        <i class="el-icon-delete-solid" @click="deleteLink(item)"></i>
                    </div>

                </li>
            </ul>
        </el-dialog>
        <el-dialog
                title="关系说明"
                :visible.sync="showLinkDetails"
                v-if="currentLink!=null&&currentLink.details!=null&&currentLink.details!=''"
                :close-on-click-modal="false"
        >
            <div v-html="currentLink.details" style="white-space: pre-wrap"></div>
        </el-dialog>
        <div class="tools">
            <div @click="saveImg" class="to to1">
                <i class="el-icon-camera-solid"></i>
            </div>
            <div @click="addPerson" class="to to2">
                <i class="el-icon-user-solid"></i>
            </div>
            <router-link to="/" class="to to3">
                <i class="el-icon-back"></i>
            </router-link>
        </div>
        <el-popover
                width="280"
                trigger="manual"
                v-model="showDetail"
                placement="top"
        >
            <div v-html="currentNode.details" v-if="currentNode" style="white-space: pre-wrap"></div>
            <div slot="reference" ref="mark" @click="showDetail = !showDetail"></div>
        </el-popover>

    </div>
</template>

<script>
    import html2canvas from 'html2canvas';
    import * as d3 from "d3";

    export default {
        name: 'Home',
        data() {
            let validateName = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入姓名'));
                } else {
                    callback();
                }
            };
            let validateSource = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入关系源'));
                } else {
                    callback();
                }
            };
            let validateTarget = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入关系目标'));
                } else {
                    callback();
                }
            };
            let validateType = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入关系类型'));
                } else {
                    callback();
                }
            };
            return {
                relationName: '',
                persons: [],
                links: [],
                showPerson: false,
                showLink: false,
                showLinkList: false,
                showToolMenu: false,
                showLinkDetails: false,//关系说明窗口
                editPersonsMode: 'add', // 'add' 或 'edit'
                editLinksMode: 'add', // 'add' 或 'edit'
                editForm: {
                    photo: '',
                    photoScale: 100,
                    name: '',
                    alias: '',
                    gender: '男性',
                    textWidth: 'auto',
                    textPo: 'bottom',
                    color: '#fa0',
                    birthDate: '',
                    deathDate: '',
                    details: ''
                },
                rules: {
                    name: [
                        {required: true, validator: validateName, trigger: 'blur'}
                    ],
                },
                linkForm: {
                    source: '',
                    target: '',
                    showArrow:false,
                    po: 'center',
                    type: '',
                    details: ''
                },
                rulesL: {
                    source: [
                        {required: true, validator: validateSource, trigger: 'blur'}
                    ],
                    target: [
                        {required: true, validator: validateTarget, trigger: 'blur'}
                    ],
                    // type: [
                    //     {required: true, validator: validateType, trigger: 'blur'}
                    // ],
                },
                predefineColors: [
                    '#00D3C4',
                    '#DE6BA6',
                    '#ffaa00',
                    '#ff0000',
                    '#13CC6C',
                    '#65C2EA',
                    '#CCCC00',
                    '#806CD0',
                    '#BB00FF',
                    '#CC0000',
                    '#666666',
                    '#0022FF',
                    '#2A9877'
                ],
                currentNode: null,
                currentLink: null,
                //currentDedail: null,
                showDetail: false,
                captureWidth: 1920,
                captureHeight: 1080,
                routeId: this.$route.params.id,
            }
        },
        mounted() {
            window.addEventListener('resize', () => {
                this.drawGraph()
            })

        },
        watch: {
            showLinkDetails: {
                handler(value) {
                    if (!value) {
                        this.currentLink = null
                    }
                },
                immediate: true
            },
            showToolMenu: {
                handler(value) {
                    if (!value) {
                        this.currentNode = null
                    }
                },
                immediate: true
            },
            currentNode: {
                handler(value) {
                    if (value) {
                        this.linkForm.source = value.name
                    }
                },
                immediate: false
            },
            $route: {
                handler(route) {
                    this.routeId = route.params.id
                    if (this.$store.state.relation.relation === null) {
                        this.$store.dispatch('relation/getAll').then((rs) => {
                            let fi = rs.filter((el) => {
                                return el.id == this.routeId
                            })
                            if (fi.length > 0) {
                                this.persons = fi[0].persons == null ? [] : fi[0].persons
                                this.links = fi[0].links == null ? [] : fi[0].links
                                this.relationName = fi[0].title
                                this.drawGraph()

                            } else {
                                this.$message({
                                    message: '找不到关系图谱',
                                    type: 'error',
                                    onClose: () => {
                                        this.$router.push({path: '/'})
                                    }
                                });
                            }

                        })
                    } else {
                        let fi = this.$store.state.relation.relation.filter((el) => {
                            return el.id == this.routeId
                        })
                        if (fi.length > 0) {
                            this.persons = fi[0].persons == null ? [] : fi[0].persons
                            this.links = fi[0].links == null ? [] : fi[0].links
                            this.relationName = fi[0].title
                            this.$nextTick(() => {
                                //this.drawGraph()
                                this.drawGraph()
                            })
                        } else {
                            this.$message({
                                message: '找不到关系图谱',
                                type: 'error',
                                onClose: () => {
                                    this.$router.push({path: '/'})
                                }
                            });
                        }

                    }

                },
                immediate: true
            },
        },
        computed: {
            whichTitle() {
                if (this.currentNode) {
                    return '修改' + this.currentNode.name + '信息'
                } else {
                    return '添加人物信息'
                }
            },
            whichTitleLink() {
                if (this.currentNode) {
                    if (this.currentLink) {
                        return '修改' + this.currentNode.name + '的人物关系网'
                    } else {
                        return '创建' + this.currentNode.name + '的人物关系网'
                    }
                }
            },
            linkList() {
                if (this.currentNode) {
                    return '管理' + this.currentNode.name + '的人物关系网'

                }
            },
            currentLinkList() {
                if (this.currentNode) {
                    let id = this.currentNode.id
                    let fi = this.links.filter((el) => {
                        return el.source.id == id || el.target.id == id
                    })
                    return fi
                }
            }
        },
        methods: {
            formatTooltip(val) {
                return val / 100;
            },
            getRealLength(str) {
                return str.replace(/[\u200B-\u200D\uFEFF]/g, '').length;
            },
            dynamicLa(selection) {
                selection.each(function () {
                    const lt = d3.select(this);
                    const type = lt._groups[0][0].__data__.type
                    const arrow = lt._groups[0][0].__data__.showArrow
                    if (type == ''&&(arrow==false||arrow==undefined)) {
                        lt.remove()
                    }
                });
            },
            dynamicLg(selection) {
                selection.each(function () {
                    const lt = d3.select(this);
                    const type = lt._groups[0][0].__data__.type
                    if (type == '') {
                        lt.remove()
                    }
                });
            },
            dynamiCircleQ(selection) {
                selection.each(function () {
                    const circle = d3.select(this);
                    const gender = circle._groups[0][0].__data__.gender
                    if (gender == '图') {
                        circle.remove()
                    }
                });
            },
            dynamicText(selection) {
                selection.each(function () {
                    const text = d3.select(this);
                    const alias = text._groups[0][0].__data__.alias
                    if (alias == '') {
                        text.remove()
                    } else {
                        let x = 0;
                        const lineHeight = 1.2;

                        let raw = text.text();
                        text.text(""); // 清空原文本

                        // 1. 先按回车 \n 拆分固定行
                        const blockLines = raw.split("\n");
                        let dy = 0;
                        blockLines.forEach(block => {
                            if (!block) return;

                            text.append("tspan")
                                .attr("x", x)
                                .attr("dy", dy ? lineHeight + "em" : "0em")
                                .text(block);
                            dy = 1


                        })


                    }
                });
            },
            dynamicCircle(selection) {
                selection.each(function () {
                    const circle = d3.select(this);
                    const details = circle._groups[0][0].__data__.details
                    const gender = circle._groups[0][0].__data__.gender
                    if (details == '' || gender == '图') {
                        circle.remove()
                    }
                });

            },
            dynamicImage(selection) {
                selection.each(function () {
                    const image = d3.select(this);
                    const gender = image._groups[0][0].__data__.gender
                    const scale = image._groups[0][0].__data__.photoScale ? image._groups[0][0].__data__.photoScale : 1
                    let scaleC = scale * 0.01


                    if (gender == '文字') {
                        image.remove()
                    } else if (gender == '图') {
                        image.attr('clip-path', null)
                        image.attr('rx', null)
                        let img = new Image()
                        img.src = image.attr('href')
                        img.onload = () => {
                            let {width, height} = img


                            image
                                .attr('width', width * scaleC.toFixed(2))
                                .attr('height', height * scaleC.toFixed(2))
                                .attr('x', width * scaleC * -0.5.toFixed(2))
                                .attr('y', height * scaleC * -0.5.toFixed(2))

                        }

                    }
                });

            },
            dynamicRect(selection) {
                let _this = this
                selection.each(function () {
                    const rect = d3.select(this);
                    const gender = rect._groups[0][0].__data__.gender
                    const name = rect._groups[0][0].__data__.name
                    const rectWidth = rect._groups[0][0].__data__.textWidth

                    if (gender == '文字' && (rectWidth != undefined && rectWidth != 'auto')) {
                        rect.attr('width', (Number(rectWidth) + 30))
                            .attr('x', (Number(rectWidth) + 30) / -2)

                    } else {
                        rect.attr('width', _this.getRealLength(name) * 14 + 20)
                            .attr('x', (_this.getRealLength(name) * 14 + 20) / -2)
                        if (gender == '图') {
                            rect.remove()

                        }
                    }
                });

            },
            wrapDynamicText(selection) {
                selection.each(function () {
                    const text = d3.select(this);
                    const gender = text._groups[0][0].__data__.gender
                    const textWidth = text._groups[0][0].__data__.textWidth
                    const textPo = text._groups[0][0].__data__.textPo
                    const maxWidth = textWidth
                    const lineHeight = 1.4;
                    if (gender == '图') {
                        text.remove()
                        return
                    }
                    if (gender == '文字' && (textWidth != undefined && textWidth != 'auto')) {
                        let x = 0;
                        if (textPo == 'right') {
                            x = 19
                        } else if (textPo == 'left') {
                            x = -(Number(textWidth) + 19)
                        } else {
                            x = Number(textWidth) * -0.5
                        }


                        let raw = text.text();
                        text.text(""); // 清空原文本

                        // 1. 先按回车 \n 拆分固定行
                        const blockLines = raw.split("\n");
                        let dy = 0;
                        blockLines.forEach(block => {
                            //if (!block) return;
                            // 2. 每一行再做 宽度自动折行


                            const chars = block.split("");
                            let line = [];

                            chars.forEach(char => {
                                line.push(char);

                                // 测量当前行宽度
                                const temp = text.append("tspan").text(line.join(""));
                                const w = temp.node().getBBox().width;
                                temp.remove();
                                if (w > maxWidth) {
                                    line.pop();
                                    text.append("tspan")
                                        .attr("x", x)
                                        .attr("dy", dy ? lineHeight + "em" : "0em")
                                        .text(line.join(''));

                                    dy = 1;
                                    line = [char];
                                }

                            })

                            // 剩余最后一行
                            if (line.length) {
                                text.append("tspan")
                                    .attr("x", x)
                                    .attr("dy", dy ? lineHeight + "em" : "0em")
                                    .text(line.join(""));
                                dy = 1;
                            }


                        })

                    }

                    //console.log(text.selectAll('tspan').nodes().length)
                    const prevE = d3.select(this.previousElementSibling)
                    const aliasE = d3.select(this.parentElement.querySelector('.alias'))
                    const infoE = d3.select(this.parentElement.querySelector('.info'))

                    let num = text.selectAll('tspan').nodes().length
                    if (num === 0) {
                        prevE.attr('height', 20)
                    } else {
                        text.attr('text-anchor', 'left')
                        prevE.attr('height', (num) * 14 * lineHeight + 30)
                        if (textPo == 'top') {
                            prevE.attr('y', ((num) * 14 * lineHeight + 30 + 4) * -1)
                            text.attr('y', ((num) * 14 * lineHeight + 4) * -1)


                            aliasE.attr('y', 20)

                        } else if (textPo == 'left') {
                            text.attr('text-anchor', 'left')
                            text.attr('y', ((num) * 14 * lineHeight + 4) * -0.5 + 15)
                            prevE.attr('x', -(Number(textWidth) + 30 + 4))
                            prevE.attr('y', ((num) * 14 * lineHeight + 30 + 4) * -0.5)


                            aliasE.selectAll('tspan').nodes().forEach((el) => {
                                d3.select(el).attr('x', (Number(textWidth) + 30) * -0.5)
                            })
                            aliasE.attr('y', (num * 14 * lineHeight + 30) * 0.5 + 1.2 * 13)

                        } else if (textPo == 'right') {
                            text.attr('text-anchor', 'left')
                            text.attr('y', ((num) * 14 * lineHeight + 4) * -0.5 + 15)
                            prevE.attr('x', 4)
                            prevE.attr('y', ((num) * 14 * lineHeight + 30 + 4) * -0.5)

                            aliasE.selectAll('tspan').nodes().forEach((el) => {
                                d3.select(el).attr('x', (Number(textWidth) + 30) * 0.5)
                            })
                            aliasE.attr('y', (num * 14 * lineHeight + 30) * 0.5 + 1.2 * 13)
                        } else {
                            aliasE.attr('y', num * 14 * lineHeight + 30 + 1.2 * 13 + 8)
                        }
                    }


                });

            },
            toName(id) {
                let fii = this.persons.filter((el) => {
                    return el.id == id
                })
                return fii[0].name

            },
            getAngle(x1, y1, x2, y2) {
                const dx = x2 - x1;
                const dy = y2 - y1;

                let radian = Math.atan2(dy, dx);
                let angle = radian * 180 / Math.PI;

                if (angle < 0) {
                    angle += 360;
                }

                //
                if (angle > 90) {
                    angle += 180
                    if (angle > 450) {
                        angle -= 180
                    }
                }
                return angle;
            },
            getAngle1(x1, y1, x2, y2) {
                const dx = x2 - x1;
                const dy = y2 - y1;

                let radian = Math.atan2(dy, dx);
                let angle = radian * 180 / Math.PI;

                if (angle < 0) {
                    angle += 360;
                }
                return angle;
            },
            drawGraph() {
                const container = this.$refs.graphContainer
                d3.select(container).selectAll('*').remove()

                const width = window.innerWidth
                const height = window.innerHeight


                const svg = d3.select(container)
                    .append('svg')
                    .attr('width', width)
                    .attr('height', height)

                const simulation = d3.forceSimulation(this.persons)
                    .force('link', d3.forceLink(this.links).id(d => d.id).distance(120))
                    .force('charge', d3.forceManyBody().strength(-width / 2))
                    .force("x", d3.forceX(width / 2))
                    .force("y", d3.forceY(height / 2))
                //.force('center', d3.forceCenter(width / 2, height / 2))


                // 添加箭头标记定义

                const def = svg.append('defs')

                def.append('clipPath')
                    .attr('id', 'circle')
                    .append('circle')
                    .attr('r', 28)


                const link = svg.append('g')
                    .attr('id', 'line')
                    .selectAll('line')
                    .data(this.links)
                    .enter()
                    .append('line')
                    //.append("path")
                    // .attr("d", d3.linkVertical() // 水平连线
                    //     .x(d => d.x)
                    //     .y(d => d.y)
                    // )
                    .attr('stroke', d => d.source.gender == '男' ? 'var(--green)' : d.source.gender == '女' ? 'var(--fen)' : d.source.gender == '无' ? 'var(--gray)' : d.source.color != undefined ? d.source.color : 'var(--yellow)')
                    .attr('stroke-opacity', 0.6)
                    //.attr('stroke-dasharray','2 2')
                    .attr('fill', 'none')


                const linkText = svg.append('g')
                    .attr('id', 'linkText')
                    .selectAll('text')
                    .data(this.links)
                    .enter()
                    .append('g')
                    .style('cursor', 'pointer')
                    .on("click", (event, d) => {
                        this.currentLink = d
                        this.showLinkDetails = true
                    })

                const linkG = linkText.append('g')
                    .call(this.dynamicLg)
                    .on("mouseenter", (event, d) => {
                        if (d.details != undefined && d.details != '') {
                            let rect = d3.select(event.target.querySelector('rect'))
                            let text = d3.select(event.target.querySelector('text'))

                            rect
                                .attr('fill', 'var(--yellow)')
                                .attr('stroke', 'var(--yellow)')

                            text
                                .attr('fill', '#fff')
                        }

                    }).on("mouseleave", (event, d) => {
                        if (d.details != undefined && d.details != '') {
                            let rect = d3.select(event.target.querySelector('rect'))
                            let text = d3.select(event.target.querySelector('text'))

                            rect
                                .attr('fill', '#fff')
                                .attr('stroke', '#aaa')

                            text
                                .attr('fill', '#444')
                        }


                    })


                const lr = linkG.append('rect')
                    .attr('width', d => d.type.length * 11 + 11)
                    .attr('height', 20)
                    .attr('x', d => (d.type.length * 11 + 11) / -2)
                    .attr('y', -10)
                    .attr('rx', 5)
                    .attr("fill", '#fff')
                    .attr('stroke', '#aaa')
                    .attr('stroke-opacity', 0.6)


                const ld = linkText.append('circle')
                    .attr('r', d => d.details != '' && d.details != undefined ? 4 : 0)
                    .attr('cx', d => (d.type.length * 11 + 22) / -2)
                    .attr('fill', 'var(--yellow)')
                    .call(this.dynamicLg)


                const lt = linkG.append('text')
                    .text(d => d.type)
                    .attr('x', d => (d.type.length * 11) / -2)
                    .attr('y', 4)
                    .attr('font-size', '11px')
                    .attr('fill', '#444')
                    .attr("text-anchor", "center")

                const arrow = linkText.append('g')
                    .call(this.dynamicLa)


                const arrowp = arrow.append('path')
                    .attr('d', d => `M${(d.type.length * 11 + 18) / 2},5L${(d.type.length * 11 + 32) / 2},0L${(d.type.length * 11 + 18) / 2},-5`)
                    .attr('fill', '#666')


                const node = svg.append('g')
                    .attr('id', 'node')
                    .selectAll('g')
                    .data(this.persons)
                    .enter()
                    .append('g')
                    .style('cursor', 'pointer')
                    .call(d3.drag()
                        .on('start', (event, d) => {
                            if (!event.active) simulation.alphaTarget(0.3).restart()
                            d.fx = d.x
                            d.fy = d.y
                        })
                        .on('drag', (event, d) => {
                            d.fx = event.x
                            d.fy = event.y
                        })
                        .on('end', (event, d) => {
                            // if (!event.active) simulation.alphaTarget(0)
                            // d.fx = null
                            // d.fy = null
                        })
                    ).on("click", (event, d) => {
                        this.toolMenu(d)
                    }).on("mouseenter", (event, d) => {
                        this.currentNode = d

                        const mark = this.$refs.mark
                        const targetEl = event.currentTarget
                        const rect = targetEl.getBoundingClientRect();
                        // 把虚拟元素定位到目标元素
                        mark.style.position = 'absolute';
                        mark.style.left = rect.left + rect.width / 2 + 'px';
                        mark.style.top = rect.top + (d.y < 140 ? -25 : 10) + 'px';
                        mark.style.width = '0px';
                        mark.style.height = rect.height + 'px';
                        if (d.details) {
                            mark.click()
                        }


                    }).on("mouseleave", (event, d) => {
                        const mark = this.$refs.mark
                        if (d.details) {
                            mark.click()
                        }

                    });

                node.append('text')
                    .text(d => d.alias)
                    .attr('class', 'alias')
                    .attr("paint-order", "stroke")
                    .attr('stroke', 'var(--bg)')
                    .attr("stroke-width", 6)
                    .attr('text-anchor', 'middle')
                    .attr('x', 0)
                    .attr('y', d => d.gender != '文字' ? 62 : 20)
                    .attr('fill', 'var(--gray)')
                    .attr('font-size', '13')
                    .call(this.dynamicText);

                node.append('circle')
                    .attr('r', d => d.gender != '文字' ? 30 : 2)
                    .attr('fill', '#fff')
                    .attr('stroke', d => d.gender == '男' ? 'var(--green)' : d.gender == '女' ? 'var(--fen)' : d.gender == '无' ? 'var(--gray)' : d.color != undefined ? d.color : 'var(--yellow)')
                    .attr('stroke-width', 2)
                    .call(this.dynamiCircleQ);

                node.append('image')
                    .attr('width', d => d.gender != '文字' ? 60 : 0)
                    .attr('height', d => d.gender != '文字' ? 60 : 0)
                    .attr('x', d => d.gender != '文字' ? -30 : 0)
                    .attr('y', d => d.gender != '文字' ? -30 : 0)
                    .attr('rx', d => d.gender != '文字' ? 30 : 0)
                    .attr('clip-path', 'url(#circle)')
                    .attr('href', d => d.photo ? d.photo : '')
                    .call(this.dynamicImage);

                node.append('circle')
                    .attr('class', 'info')
                    .attr('r', d => d.details != '' && d.details != undefined ? 4 : 0)
                    .attr('cy', d => d.gender != '文字' ? -34 : (d.textWidth != 'auto' && d.textWidth != undefined) ? d.textPo == 'top' ? 8 : -8 : -28)
                    .attr('fill', d => d.gender == '男' ? 'var(--green)' : d.gender == '女' ? 'var(--fen)' : d.gender == '无' ? 'var(--gray)' : d.color != undefined ? d.color : 'var(--yellow)')
                    .call(this.dynamicCircle);

                node.append('rect')
                    .attr('class', 'rect')
                    .attr('y', d => d.gender != '文字' ? 24 : (d.textWidth != 'auto' && d.textWidth != undefined) ? d.textPo == 'top' ? -4 : 4 : -24)
                    .attr('rx', 10)
                    .attr("fill", d => d.gender == '男' ? 'var(--green)' : d.gender == '女' ? 'var(--fen)' : d.gender == '无' ? 'var(--gray)' : d.color != undefined ? d.color : 'var(--yellow)')
                    .call(this.dynamicRect);

                node.append('text')
                    .text(d => d.name)
                    .attr('text-anchor', 'middle')
                    .attr('x', 0)
                    .attr('y', d => d.gender != '文字' ? 40 : (d.textWidth != 'auto' && d.textWidth != undefined) ? d.textPo == 'top' ? -4 : 35 : -9)
                    .attr('fill', 'white')
                    .attr('font-size', '14')
                    .call(this.wrapDynamicText);


                simulation.on('tick', () => {


                    link
                    // .attr('d', d3.linkVertical() // 水平连线
                    //     .x(d => d.x)
                    //     .y(d => d.y))
                        .attr('x1', d => d.source.x)
                        .attr('y1', d => d.source.y)
                        .attr('x2', d => d.target.x)
                        .attr('y2', d => d.target.y)

                    linkText
                    //.attr('transform', d => `translate(${(d.source.x + d.target.x) / 2},${(d.source.y + d.target.y) / 2})`)
                        .attr('transform', d => {
                            let newX, newY

                            if (d.po == undefined || d.po == 'center') {
                                newX = (d.source.x + d.target.x) / 2
                                newY = (d.source.y + d.target.y) / 2
                            } else {
                                let angle = this.getAngle1(d.source.x, d.source.y, d.target.x, d.target.y)

                                let dx = d.target.x - d.source.x;
                                let dy = d.target.y - d.source.y;
                                let long = Math.sqrt(dx * dx + dy * dy);

                                let R = d.target.gender != '文字' ? long - (d.type.length * 11 + 11 + 12) * 0.5 - 36 : long - (d.type.length * 11 + 11 + 12) * 0.5 - 12

                                let rad = angle * Math.PI / 180;
                                newX = (d.source.x) + R * Math.cos(rad);
                                newY = (d.source.y) + R * Math.sin(rad);
                            }


                            return `translate(${newX},${newY})`

                        })
                    linkG
                        .attr('transform', d => `rotate(${this.getAngle(d.source.x, d.source.y, d.target.x, d.target.y)})`)
                    arrow
                        .attr('transform', d => `rotate(${this.getAngle1(d.source.x, d.source.y, d.target.x, d.target.y)})`)
                    ld
                        .attr('transform', d => `rotate(${this.getAngle1(d.source.x, d.source.y, d.target.x, d.target.y)})`)

                    node
                        .attr('transform', d => `translate(${d.x},${d.y})`)
                })
            },
            async handleRemove() {
                this.editForm.photo = ''
                let arr = this.currentNode.photo.split('/')
                let len = arr.length
                const {data} = await this.$supabase
                    .storage
                    .from('my')
                    .remove(arr[len - 1])
                this.$message.success('头像删除成功！');
            },
            async handleAvatarSuccess(res, file) {
                const {error} = await this.$supabase
                    .storage
                    .from('my')
                    .upload(file.name, file.raw)
                if (error) {
                    this.$message.error(error);
                } else {
                    this.$message.success('头像上传成功！');
                    const {data} = await this.$supabase
                        .storage
                        .from('my')
                        .getPublicUrl(file.name)
                    this.editForm.photo = data.publicUrl
                }

            },
            beforeAvatarUpload(file) {
                let types = ['image/jpeg', 'image/png', 'image/gif']
                const isJPG = types.indexOf(file.type) > -1;
                const isLt2M = file.size / 1024 / 1024 < 10;

                if (!isJPG) {
                    this.$message.error('上传头像只能是jpg,png,gif图片格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过10MB!');
                }
                return isJPG && isLt2M;
            },
            saveImg() {
                let x = 0
                let y = 0
                if (this.captureWidth > window.innerWidth) {
                    x += (window.innerWidth - this.captureWidth) * 0.5
                } else {
                    x += (window.innerWidth - this.captureWidth) * 0.5
                }

                html2canvas(document.querySelector('.tree-container'), {
                    useCORS: true,
                    width: this.captureWidth + 120,
                    height: this.captureHeight + 120,
                    x: x - 60,
                    y: y - 60,
                    backgroundColor: window.getComputedStyle(document.body).backgroundColor
                }).then((canvas) => {
                    let lastpic
                    canvas.toBlob((blob) => {
                        lastpic = URL.createObjectURL(blob)
                        let eleLink = document.createElement('a');
                        eleLink.download = this.relationName + '族谱';
                        eleLink.style.display = 'none';
                        eleLink.href = lastpic;
                        eleLink.click();
                    }, 'image/png', 1);
                });
            },
            toolMenu(node) {
                this.currentNode = node
                this.showToolMenu = true
            },
            addLink() {
                this.editLinksMode = 'add'
                this.showLink = true
                this.currentLink = ''//很重要
                this.linkForm.target = ''
                this.linkForm.type = ''
                this.linkForm.details = ''
                this.linkForm.showArrow = false
                this.linkForm.po = 'center'
            },
            editLink(node) {
                this.editLinksMode = 'edit'
                this.showLink = true
                this.currentLink = node
                this.linkForm.source = node.source.name
                this.linkForm.target = node.target.name
                this.linkForm.type = node.type
                this.linkForm.showArrow = node.showArrow==undefined?false:node.showArrow
                this.linkForm.po = node.po
                this.linkForm.details = node.details
            },
            deleteLink(node) {
                const index = this.getIndex(this.links, node)
                if (index > -1) {
                    this.links.splice(index, 1)
                    this.drawGraph()
                }
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.saveRelation('links')
            },
            listLink() {
                this.showLinkList = true
            },
            addPerson() {
                this.editPersonsMode = 'add'
                this.showPerson = true
                let xb = '男'
                this.editForm = {
                    photo: '',
                    photoScale: 100,
                    name: '',
                    alias: '',
                    gender: xb,
                    textWidth: 'auto',
                    textPo: 'bottom',
                    color: '#fa0',
                    birthDate: '',
                    deathDate: '',
                    details: '',
                }
            },
            getIndex(arr, obj) {
                let index = null;
                let key = Object.keys(obj)[0];
                arr.every(function (value, i) {
                    if (value[key] === obj[key]) {
                        index = i;
                        return false;
                    }
                    return true;
                });
                return index;
            },
            async deleteNode() {
                //person
                let node = this.currentNode
                const index = this.getIndex(this.persons, node)
                if (index > -1) {
                    this.persons.splice(index, 1)
                    this.drawGraph()
                }
                //storage
                let arr = node.photo.split('/')
                let len = arr.length
                await this.$supabase
                    .storage
                    .from('my')
                    .remove(arr[len - 1])
                //links

                let delList = []
                let fi = this.links.filter((el) => {
                    return el.source.id == node.id || el.target.id == node.id
                })
                if (fi.length > 0) {
                    fi.forEach((el) => {
                        delList.push(el.index)
                    })
                    let k = 0;
                    for (let j in delList.sort()) {
                        this.links.splice(delList[j] - k, 1);
                        k++;
                    }
                    this.drawGraph()
                }


                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.showToolMenu = false
                this.saveRelation('links')
                this.saveRelation('persons')
            },
            editPerson() {
                this.showPerson = true
                this.editPersonsMode = 'edit'
                this.editForm = {
                    photo: this.currentNode.photo,
                    photoScale: this.currentNode.photoScale,
                    name: this.currentNode.name,
                    alias: this.currentNode.alias,
                    gender: this.currentNode.gender,
                    textWidth: this.currentNode.textWidth,
                    textPo: this.currentNode.textPo,
                    color: this.currentNode.color,
                    birthDate: this.currentNode.birthDate,
                    deathDate: this.currentNode.deathDate,
                    details: this.currentNode.details,
                }
            },
            async saveRelation(text) {
                if (text == 'persons') {
                    await this.$supabase.from('relation').update({'persons': this.persons}).eq('id', this.routeId)
                }
                if (text == 'links') {
                    const links = []
                    this.links.forEach((el) => {
                        links.push({
                            source: el.source.id,
                            target: el.target.id,
                            type: el.type,
                            showArrow: el.showArrow,
                            po: el.po,
                            details: el.details
                        })
                    })
                    await this.$supabase.from('relation').update({'links': links}).eq('id', this.routeId)
                }

                await this.$store.dispatch('relation/getAll')

            },

            submitForm1(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        const source = this.persons.find(n => n.name === this.linkForm.source)
                        const target = this.persons.find(n => n.name === this.linkForm.target)
                        if (source && target) {
                            this.$message({
                                message: '添加成功',
                                type: 'success'
                            });
                            this.saveLinks(source, target)
                        } else {
                            this.$message({
                                message: '人物不存在',
                                type: 'error'
                            });
                        }

                    } else {
                        return false;
                    }
                });
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        this.savePersons()

                    } else {
                        return false;
                    }
                });
            },
            savePersons() {
                if (this.editPersonsMode === 'add') {
                    const newNode = {
                        id: Date.now(),
                        photo: this.editForm.photo,
                        photoScale: this.editForm.photoScale,
                        name: this.editForm.name,
                        alias: this.editForm.alias,
                        gender: this.editForm.gender,
                        textWidth: this.editForm.textWidth,
                        textPo: this.editForm.textPo,
                        color: this.editForm.color,
                        birthDate: this.editForm.birthDate,
                        deathDate: this.editForm.deathDate,
                        details: this.editForm.details,
                    }
                    this.persons.push(newNode)
                    this.drawGraph()


                } else if (this.editPersonsMode === 'edit' && this.currentNode) {
                    this.currentNode.photo = this.editForm.photo
                    this.currentNode.photoScale = this.editForm.photoScale
                    this.currentNode.name = this.editForm.name
                    this.currentNode.alias = this.editForm.alias
                    this.currentNode.gender = this.editForm.gender
                    this.currentNode.textWidth = this.editForm.textWidth
                    this.currentNode.textPo = this.editForm.textPo
                    this.currentNode.color = this.editForm.color
                    this.currentNode.birthDate = this.editForm.birthDate
                    this.currentNode.deathDate = this.editForm.deathDate
                    this.currentNode.details = this.editForm.details
                    this.drawGraph()
                }
                this.saveRelation('persons')
                this.showPerson = false
                //this.showToolMenu = false
            },
            saveLinks(source, target) {
                if (this.editLinksMode === 'add') {
                    const newNode = {
                        source: source.id,
                        target: target.id,
                        type: this.linkForm.type,
                        showArrow: this.linkForm.showArrow,
                        po: this.linkForm.po,
                        details: this.linkForm.details,
                    }
                    this.links.push(newNode)
                    this.drawGraph()

                } else if (this.editLinksMode === 'edit') {
                    this.currentLink.source.name = this.linkForm.source
                    this.currentLink.target.name = this.linkForm.target
                    this.currentLink.type = this.linkForm.type
                    this.currentLink.showArrow = this.linkForm.showArrow
                    this.currentLink.po = this.linkForm.po
                    this.currentLink.details = this.linkForm.details
                    this.drawGraph()
                }
                this.saveRelation('links')
                this.showLink = false
                //this.showToolMenu = false
            },
        }
    }
</script>

<style scoped>
    .tree-container {
        width: 100vw;
        height: 100vh;
    }

    .yellow {
        color: var(--green);
    }

    .home {

    }

    .tools {
        position: fixed;
        right: 20px;
        top: 20px;
        z-index: 999;
        display: flex;
        flex-direction: column;
        gap: calc(clamp(26px, 8vw, 50px) * 0.2)
    }

    .tools .to {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border-radius: 50%;
        color: var(--white);
        padding: 10px;
        text-decoration: none;
    }

    .tools .to i {
        color: var(--white);
        font-size: calc(clamp(26px, 8vw, 56px) * 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .tools .to span {
        width: calc(clamp(26px, 8vw, 56px) * 0.6);
        height: calc(clamp(26px, 8vw, 56px) * 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .tools .to span img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .tools .to1 {
        background-color: var(--blue);
    }

    .tools .to2 {
        background-color: var(--yellow);
    }

    .tools .to3 {
        background-color: var(--green);
    }

    .btns {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
    }

    .btns .hf {
        width: calc(50% - 7px);
    }

    .btns .hf button {
        width: 100%;
        height: 14vh;
    }

    .linkList {
        gap: 5px;
        display: flex;
        flex-direction: column;
    }

    .linkList li {
        display: flex;
        align-items: center;
        border: solid 1px var(--line);
        padding: 0px 5px;
        background: var(--bg);
    }

    .linkList li .ti {
        width: calc(100% - 50px);
    }

    .linkList li .dos {
        width: 50px;
        display: flex;
        gap: 5px;
        padding: 5px 0;
    }

    .linkList li .dos i {
        cursor: pointer;
        background: var(--green);
        color: #fff;
        border-radius: 50%;
        padding: 4px;
    }


</style>

